/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  chartLegendCellLineWithDots,
  chartLegendRow,
  ChartSpecsWithLegend,
} from '@gh/builder-shared-charts';
import {
  DashboardChartType,
  SalesLeadsBudgetsDto,
  SalesLeadsBudgetsPoint,
  SalesLeadsBudgetsTooltip,
  SalesLeadsBudgetsValue,
} from '@gh/builder-shared-data';
import { DateTimeTypes } from '@gh/common-shared';
import { offsetDate } from '@gh/core-util';
import { camelCase, head, join, map, upperFirst, values } from 'lodash';

export type SalesLeadsBudgets = SalesLeadsBudgetsDto;
export const salesLeadsBudgetsSpecsFromDto = (dto: SalesLeadsBudgetsDto, labels: any): ChartSpecsWithLegend => {
  const buildTooltip = (type: DashboardChartType, tooltipItems: SalesLeadsBudgetsTooltip[]): string => {
    const typeValue = labels[type] || '';
    let tooltipHtml: string = `<div>${typeValue}</div>`;
    tooltipItems.forEach((item: SalesLeadsBudgetsTooltip) => {
      const row = join(values(item), ': ');
      tooltipHtml += `<div>${row}</div>`;
    });

    return tooltipHtml;
  };

  const dataTable: any[][] = [];
  dataTable.push([
    { type: 'string', label: '' },
  ]);

  map(dto.legend, 'type')
    .forEach((type) => {
      head(dataTable)!.push(...[
        { type: 'number', label: upperFirst(camelCase(type)) },
        { type: 'string', role: 'tooltip', p: { html: true } },
      ]);
    });

  dto.values.forEach((value: SalesLeadsBudgetsValue) => {
    const date = DateTimeTypes.ShortMonthYear
      .format(offsetDate(new Date(value.xAxisValue)))
      .split(' ')
      .join('\n');

    const rowValues: any[] = [date];

    map(dto.legend, 'type')
      .forEach((type) => {
        const point = value.points.find((p: SalesLeadsBudgetsPoint) => p.type === upperFirst(camelCase(type)));
        if (point) {
          rowValues.push(...[point.yAxisValue, buildTooltip(point.type, point.tooltip)]);
        }
      });

    dataTable.push(rowValues);
  });

  return <any>{
    legendLayout: [
      chartLegendRow(
        chartLegendCellLineWithDots('lbl_sales', '#009ce7'),
        chartLegendCellLineWithDots('lbl_leads', '#00ca00'),
        chartLegendCellLineWithDots('lbl_sales_budgets', '#ffa534'),
        chartLegendCellLineWithDots('lbl_leads_budgets', '#ff0000')),
    ],
    chartType: 'LineChart',
    dataTable,
    options: {
      colors: ['#009ce7', '#00ca00', '#ffa534', '#ff0000'],
      vAxis: {
        viewWindow: {
          min: 0,
        },
        gridlines: {
          color: 'transparent',
        },
        textStyle: {
          color: '#8b8b8b',
          fontSize: 12,
        },
      },
    },
    legend: dto.legend,
  };
};
